/**
 * Client Portal Page
 * 
 * READ-ONLY PORTAL for clients to view their projects.
 * No login required - token-based access.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { ClientPortalPage } from '../components/ClientPortalComponents';

export function ClientPortal() {
  const { token } = useParams();
  
  return <ClientPortalPage token={token} />;
}

export default ClientPortal;
